export default __webpack_public_path__ + "static/media/send.220b96bf.svg";